import { template } from "@ember/template-compiler";
import styles from '@hokulea/core/content.module.css';
import { or } from '../-private/helpers';
import type { TOC } from '@ember/component/template-only';
export interface CardSignature {
    Element: HTMLDivElement;
    Blocks: {
        header?: [];
        footer?: [];
        body?: [];
        default?: [];
    };
}
const Card: TOC<CardSignature> = template(`
  <div class={{styles.card}} ...attributes>
    {{#if (has-block "header")}}
      <div class={{styles.header}} part="header">
        {{yield to="header"}}
      </div>
    {{/if}}

    {{#if (or (has-block "body") (has-block))}}
      <div class={{styles.body}} part="body">
        {{#if (has-block "body")}}
          {{yield to="body"}}
        {{else if (has-block)}}
          {{yield}}
        {{/if}}
      </div>
    {{/if}}

    {{#if (has-block "footer")}}
      <div class={{styles.footer}} part="footer">
        {{yield to="footer"}}
      </div>
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default Card;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy9jb21wb25lbnRzL2NhcmQuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZXMgZnJvbSAnQGhva3VsZWEvY29yZS9jb250ZW50Lm1vZHVsZS5jc3MnO1xuXG5pbXBvcnQgeyBvciB9IGZyb20gJy4uLy1wcml2YXRlL2hlbHBlcnMnO1xuXG5pbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ2FyZFNpZ25hdHVyZSB7XG4gIEVsZW1lbnQ6IEhUTUxEaXZFbGVtZW50O1xuICBCbG9ja3M6IHtcbiAgICBoZWFkZXI_OiBbXTtcbiAgICBmb290ZXI_OiBbXTtcbiAgICBib2R5PzogW107XG4gICAgZGVmYXVsdD86IFtdO1xuICB9O1xufVxuXG5jb25zdCBDYXJkOiBUT0M8Q2FyZFNpZ25hdHVyZT4gPSA8dGVtcGxhdGU-XG4gIDxkaXYgY2xhc3M9e3tzdHlsZXMuY2FyZH19IC4uLmF0dHJpYnV0ZXM-XG4gICAge3sjaWYgKGhhcy1ibG9jayBcImhlYWRlclwiKX19XG4gICAgICA8ZGl2IGNsYXNzPXt7c3R5bGVzLmhlYWRlcn19IHBhcnQ9XCJoZWFkZXJcIj5cbiAgICAgICAge3t5aWVsZCB0bz1cImhlYWRlclwifX1cbiAgICAgIDwvZGl2PlxuICAgIHt7L2lmfX1cblxuICAgIHt7I2lmIChvciAoaGFzLWJsb2NrIFwiYm9keVwiKSAoaGFzLWJsb2NrKSl9fVxuICAgICAgPGRpdiBjbGFzcz17e3N0eWxlcy5ib2R5fX0gcGFydD1cImJvZHlcIj5cbiAgICAgICAge3sjaWYgKGhhcy1ibG9jayBcImJvZHlcIil9fVxuICAgICAgICAgIHt7eWllbGQgdG89XCJib2R5XCJ9fVxuICAgICAgICB7e2Vsc2UgaWYgKGhhcy1ibG9jayl9fVxuICAgICAgICAgIHt7eWllbGR9fVxuICAgICAgICB7ey9pZn19XG4gICAgICA8L2Rpdj5cbiAgICB7ey9pZn19XG5cbiAgICB7eyNpZiAoaGFzLWJsb2NrIFwiZm9vdGVyXCIpfX1cbiAgICAgIDxkaXYgY2xhc3M9e3tzdHlsZXMuZm9vdGVyfX0gcGFydD1cImZvb3RlclwiPlxuICAgICAgICB7e3lpZWxkIHRvPVwiZm9vdGVyXCJ9fVxuICAgICAgPC9kaXY-XG4gICAge3svaWZ9fVxuICA8L2Rpdj5cbjwvdGVtcGxhdGU-O1xuXG5leHBvcnQgZGVmYXVsdCBDYXJkO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLFlBQVksbUNBQW1DO0FBRXRELFNBQVMsRUFBRSxRQUFRLHNCQUFzQjtBQUV6QyxjQUFjLEdBQUcsUUFBUSxpQ0FBaUM7QUFFMUQsaUJBQWlCO0lBQ2YsU0FBUztJQUNUO1FBQ0U7UUFDQTtRQUNBO1FBQ0E7OztBQUlKLE1BQU0sTUFBTSxJQUFJLGlCQUFpQixTQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXdCM0MsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBO0FBRVYsZUFBZSxLQUFLIn0